import { createSlice } from '@reduxjs/toolkit';
import { authLogoutThunk, setDarkThemeReducer, setIsLoadingReducer } from './appActions';

export interface AppState {
  isLoading: boolean;
  windowHeight: number;
  windowWidth: number;
  darkTheme: boolean;
}

const initialState: AppState = {
  isLoading: false,
  windowHeight: window.innerWidth,
  windowWidth: window.innerHeight,
  darkTheme: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState: initialState,
  reducers: {
    setDarkTheme: setDarkThemeReducer,
    setIsLoading: setIsLoadingReducer,
  },
  extraReducers: (builder) => {
    builder
      .addCase(authLogoutThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(authLogoutThunk.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(authLogoutThunk.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setDarkTheme, setIsLoading } = appSlice.actions;
export default appSlice.reducer;
